'use client';

import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { motion, type Variants } from 'motion/react';
import { getVariants, useAnimateIconContext, IconWrapper, type IconProps } from '@/components/animate-ui/icons/icon';
type RadioTowerProps = IconProps<keyof typeof animations>;
const animations = {
  default: (() => {
    const animation: Record<string, Variants> = {};
    for (let i = 1; i <= 2; i++) {
      animation[`path${i}`] = {
        initial: {
          opacity: 1,
          scale: 1
        },
        animate: {
          opacity: 0,
          scale: 0,
          transition: {
            opacity: {
              duration: 0.2,
              ease: 'easeInOut',
              repeat: 1,
              repeatType: 'reverse',
              repeatDelay: 0.2,
              delay: 0.2 * (i - 1)
            },
            scale: {
              duration: 0.2,
              ease: 'easeInOut',
              repeat: 1,
              repeatType: 'reverse',
              repeatDelay: 0.2,
              delay: 0.2 * (i - 1)
            }
          }
        }
      };
    }
    return animation;
  })() satisfies Record<string, Variants>
} as const;
function IconComponent(t0) {
  const $ = _c(20);
  let props;
  let size;
  if ($[0] !== t0) {
    ({
      size,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
    $[2] = size;
  } else {
    props = $[1];
    size = $[2];
  }
  const {
    controls
  } = useAnimateIconContext();
  let t1;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = getVariants(animations);
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const variants = t1;
  let t2;
  let t3;
  if ($[4] !== controls) {
    t2 = <motion.path d="M7.8 4.7a6.14 6.14 0 0 0-.8 7.5" variants={variants.path1} initial="initial" animate={controls} />;
    t3 = <motion.path d="M4.9 1.9 C1 5.8 1 12.2 4.9 16.1" variants={variants.path2} initial="initial" animate={controls} />;
    $[4] = controls;
    $[5] = t2;
    $[6] = t3;
  } else {
    t2 = $[5];
    t3 = $[6];
  }
  let t4;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <circle cx="12" cy="9" r="2" />;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  let t6;
  if ($[8] !== controls) {
    t5 = <motion.path d="M16.2 4.8c2 2 2.26 5.11.8 7.47" variants={variants.path1} initial="initial" animate={controls} />;
    t6 = <motion.path d="M19.1 1.9a9.96 9.96 0 0 1 0 14.1" variants={variants.path2} initial="initial" animate={controls} />;
    $[8] = controls;
    $[9] = t5;
    $[10] = t6;
  } else {
    t5 = $[9];
    t6 = $[10];
  }
  let t7;
  let t8;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <path d="M9.5 18h5" />;
    t8 = <path d="m8 22 4-11 4 11" />;
    $[11] = t7;
    $[12] = t8;
  } else {
    t7 = $[11];
    t8 = $[12];
  }
  let t9;
  if ($[13] !== props || $[14] !== size || $[15] !== t2 || $[16] !== t3 || $[17] !== t5 || $[18] !== t6) {
    t9 = <motion.svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" {...props}>{t2}{t3}{t4}{t5}{t6}{t7}{t8}</motion.svg>;
    $[13] = props;
    $[14] = size;
    $[15] = t2;
    $[16] = t3;
    $[17] = t5;
    $[18] = t6;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  return t9;
}
function RadioTower(props) {
  const $ = _c(2);
  let t0;
  if ($[0] !== props) {
    t0 = <IconWrapper icon={IconComponent} {...props} />;
    $[0] = props;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
export { animations, RadioTower, RadioTower as RadioTowerIcon, type RadioTowerProps, type RadioTowerProps as RadioTowerIconProps };